import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const createRouter = () =>
    new Router({
        mode: 'history',
        scrollBehavior: () => ({ x: 0, y: 0 }),
        linkActiveClass: 'active',
        base: __dirname,
        routes: []
    });

const router = createRouter();

export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher;
}

export default router;
